import './index.css';
import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import classnames from 'classnames';
import { Badge } from '@hh.ru/magritte-ui-badge';
import { Card } from '@hh.ru/magritte-ui-card';
import { CellRightLabel } from '@hh.ru/magritte-ui-cell';
import { TreeSelectorItemBase } from './TreeSelectorItemBase.js';

const MobileParentItem = ({ collection, item, selected, onClick, isSearch, parentId, renderItem = TreeSelectorItemBase, }) => {
    const childrenSelectedCount = useMemo(() => {
        let count = 0;
        collection.walkChildren(item.id, (model) => {
            if (selected.includes(model.id)) {
                count += 1;
            }
        });
        return count;
    }, [collection, selected, item.id]);
    const labelRight = (jsx(CellRightLabel, { badge: childrenSelectedCount ? jsx(Badge, { children: childrenSelectedCount.toString() }) : undefined }));
    return (jsx(Card, { padding: 16, borderRadius: 12, borderWidth: "default", stretched: true, onClick: onClick, "data-qa": classnames('tree-selector-item', `tree-selector-item-${item.id}`, {
            [`tree-selector-child-${parentId}`]: parentId,
        }), children: renderItem({ item, labelRight, childrenSelectedCount, isSearch, isXS: true, isParent: true }) }));
};

export { MobileParentItem };
//# sourceMappingURL=MobileParentItem.js.map
